
const $b922f1f6b09a9a33$var$form = document.querySelector(".form");
const $b922f1f6b09a9a33$var$email = document.querySelector(".email");
const $b922f1f6b09a9a33$var$errorMessage = document.querySelector(".error-message");
const $b922f1f6b09a9a33$var$submitButton = document.querySelector(".submit-btn");
$b922f1f6b09a9a33$var$submitButton.addEventListener("click", $b922f1f6b09a9a33$var$displayErr);
$b922f1f6b09a9a33$var$form.addEventListener("submit", (e)=>{
    e.preventDefault();
});
function $b922f1f6b09a9a33$var$displayErr() {
    if ($b922f1f6b09a9a33$var$email.validity.typeMismatch) {
        $b922f1f6b09a9a33$var$errorMessage.textContent = "Please provide a valid email address";
        $b922f1f6b09a9a33$var$email.style.border = "solid 1px hsl(354, 100%, 66%)";
    } else if ($b922f1f6b09a9a33$var$email.value.length === 0) {
        $b922f1f6b09a9a33$var$errorMessage.textContent = "Whoops! It looks like you forgot to add your email";
        $b922f1f6b09a9a33$var$email.style.border = "solid 1px hsl(354, 100%, 66%)";
    } else $b922f1f6b09a9a33$var$errorMessage.textContent = "";
}


console.log("Parcel is working. Hurray!");


//# sourceMappingURL=index.ea248ff0.js.map
